// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hl-0";
export var actionModalContentContainer = "_hl-1";
export var createTagButton = "_hl-2";
export var footerContainer = "_hl-7";
export var fullWidthDivider = "_hl-3";
export var hasCreateTagButton = "_hl-4";
export var noCreateTagButton = "_hl-5";
export var tagsContainer = "_hl-6";
export var tagsModalContentContainer = "_hl-8";